// extracted by css-extract-rspack-plugin
export default {"cls1":"Search-cls1_4VY","cls2":"Search-cls2_njs Search-cls1_4VY","leftAlign":"Search-leftAlign_VJt"};